import React from 'react'
  import styles from './index.module.sass'
import FreestyleGuideButton from './FreestyleButtons'
import { connect } from 'react-redux'
import { GlobalState } from 'reducers'
import FreestyleContent from './Content/freestyle'

interface Props {
  active: boolean,
  contentOpened: boolean
}

const FreestyleAsideRight: React.FC<Props> = ({active, contentOpened}) => {
  
  return (
    
    <div className={styles.root}>
      <div className={styles.wrapper} style={{alignItems: 'center'}}>
          <div style={{transition: 'all .3s'}} className={`${styles.content} ${contentOpened ? styles.content_opened :''}`} >
              <FreestyleContent/>
          </div>
          <div className={styles.navigation_wrapper}>
              <div className={`${styles.navigation_f} ${active ? styles.navigation_f_active : ''}`}>
                <FreestyleGuideButton/>
              </div>
          </div>
      </div>   
  </div>
  )
}

export default connect(
  (state: GlobalState) => ({
    active: state.freestyle.active,
    contentOpened: state.freestyle.contentOpened
  })
)(FreestyleAsideRight)
